import { MagnifyingGlassIcon } from "@heroicons/react/20/solid";
import { CircularProgress, Typography } from "@mui/material";
import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CustomModal from "../../components/modals/Index";
import { getAuthData } from "../../features/auth/authSlice";
import {
  closeGlobalModal,
  getDefaultState,
  openGlobalModal,
} from "../../features/defaultSlice";
import {
  getJobsData,
  searchGlobalData,
  setPagination,
} from "../../features/jobs/jobs";
import * as manualReassignment from "../../features/jobs/manualReassignment";
import { AppType, JobStatus } from "../../utils/helper";
import TableLayout from "../table/CustomTable";

export default function GlobalSearch() {
  const [value, setValue] = React.useState(""),
    { appType } = useSelector(getAuthData);
  const { _global_modal } = useSelector(getDefaultState);
  const pageSize = 10;
  const { _globalSearchLoading, _globalSearchResult } =
    useSelector(getJobsData);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSearch = ({ target: { value } }) => {
    setValue(value);
  };

  useEffect(
    () => {
      let cb = () => {};
      if (value.trim()) {
        cb = setTimeout(
          (_) =>
            (async () => {
              const res = await dispatch(
                searchGlobalData({ accountNumber: value?.trim() })
              ).unwrap();
              res?.success && dispatch(openGlobalModal(true));
            })(),
          1000
        );
      }

      return () => {
        clearTimeout(cb);
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [value]
  );

  const digestedResult = useMemo(
    function () {
      let data = null;
      try {
        return _globalSearchResult
          ?.map((res, indx) => {
            if (indx >= pageSize) return null;
            const status = JobStatus.filter(
              (status) => res?.JobStatus === status?.id
            )?.[0];

            return {
              ...(AppType.cs === appType
                ? { "CS ID": res?.AcctRefID }
                : { "CAV ID": res?.AcctRefID }),
              "Account Number": res?.AcctNumber,
              "Account Name": res?.AcctName,
              queue: status?.name,
              _data: status,
            };
          })
          .filter(Boolean);
      } catch (error) {
        console.error(error);
      }
      return data;
    },
    [_globalSearchResult, appType]
  );

  const dropdownData = {
    visible: true,
    type: "text",
    text: (
      <div>
        <span className={"px-3 py-2 rounded-full text-blue-600 bg-blue-100"}>
          <span
            id="circle__"
            className="rounded-full inline-block mr-2"
            style={{ border: `4px solid blue` }}
          ></span>
          Navigate
        </span>
      </div>
    ),
    action: (e, state) => {
      dispatch(closeGlobalModal(false));
      dispatch(setPagination({ page: 1, search: value?.trim() }));
      dispatch(
        manualReassignment?.setPagination({
          page: 1,
          search: value?.trim(),
        })
      );
      navigate(state?._data?.url, {
        state: value?.trim(),
        replace: true,
      });
    },
  };

  return (
    <div className="relative mt-2 rounded-md w-[35%] hidden md:block">
      <div className="cursor-pointer absolute inset-y-0 left-0 flex items-center pl-3 mb-1">
        {_globalSearchLoading ? (
          <CircularProgress size="19px" sx={{ color: "#D70900" }} />
        ) : (
          <MagnifyingGlassIcon className="h-5 w-5 text-[#535763]" />
        )}
      </div>
      <input
        type="text"
        name="search"
        id="search"
        value={value}
        onChange={handleSearch}
        className="block w-full bg-[#F9F9F9] rounded-[5px] border-0  py-1.5 pl-10 text-gray-900 ring-1 ring-inset ring-[#EFEFF2] placeholder:text-[#535763] focus:shadow-md transition-shadow focus:bg-[#fdfcfc] focus:ring-1 focus:outline-none focus:ring-inset focus:ring-[#e8e8ec] sm:text-sm sm:leading-6"
        placeholder={"Global search..."}
      />

      {_globalSearchResult && (
        <CustomModal
          {...{
            maxWidth: "1000px",
            title: "Search result",
            open: _global_modal,
            close: (_) => dispatch(closeGlobalModal(false)),
          }}
        >
          <div>
            <Typography>
              Below is the search result for{" "}
              <span style={{ color: "#D70900" }}>`{value?.trim()}`</span>
            </Typography>
          </div>
          <TableLayout
            {...{
              data: digestedResult,
              pagination: {
                pageSize: 5,
                page: 1,
                total: _globalSearchResult.length,
                length: 5 * 1,
                hidden: true,
              },
              isLoading: _globalSearchLoading,
              action: dropdownData,
              serials: false,
            }}
          />
        </CustomModal>
      )}
    </div>
  );
}
